import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { api, sessao, FLUXO, ST_LABEL, ST_COR } from '../api';

const PIE = ['#e8590c', '#3b7dd8', '#e6a817', '#9b59b6', '#d64545', '#6c8ea3'];

function KPI({ t, v, s, cor, onClick }) {
  return (
    <div className="card kpi" onClick={onClick}
      style={{ borderTopColor: cor, cursor: onClick ? 'pointer' : 'default' }}>
      <div className="t">{t}</div>
      <div className="v">{v}</div>
      <div className="s">{s}</div>
    </div>
  );
}

export default function Dashboard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [erro, setErro] = useState('');
  useEffect(() => { api('/dashboard').then(setD).catch(e => setErro(e.message)); }, []);

  if (erro) return <div className="erro">{erro}</div>;
  if (!d) return <div className="card">Carregando…</div>;

  const porStatus = FLUXO.map(s => ({
    nome: ST_LABEL[s], qtd: Number(d.porStatus.find(x => x.status === s)?.qtd || 0), cor: ST_COR[s],
  }));
  const porLoja = d.porLoja.map(l => ({ nome: l.nome.split('/')[0], qtd: Number(l.qtd) }));

  return (
    <div className="grid">
      <h2>Dashboard</h2>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))' }}>
        <KPI t="OS em aberto" v={d.kpi.abertas} s="em produção agora" cor="var(--azul)"
          onClick={() => nav('/ordens')} />
        <KPI t="Concluídas" v={d.kpi.concluidas} s="entregues na loja" cor="var(--ok)"
          onClick={() => nav('/ordens?status=recebido_loja')} />
        <div className="card kpi" style={{ borderTopColor: 'var(--vermelho)' }}>
          <div className="t">Atrasadas</div>
          <div className="v" onClick={() => nav('/ordens?atrasadas=1')}
            style={{ cursor: 'pointer', color: 'var(--vermelho)' }}
            title="Ver as OS atrasadas">{d.kpi.atrasadas}</div>
          <div className="s">
            {sessao.usuario?.perfil === 'admin' ? (<>
              há <input defaultValue={d.kpi.dias_atraso}
                style={{ width: 34, border: '1px solid var(--linha)', borderRadius: 4, textAlign: 'center', fontSize: 12 }}
                onBlur={e => {
                  const v = e.target.value;
                  if (v && Number(v) !== d.kpi.dias_atraso)
                    api('/config', { method: 'PATCH', body: { dias_atraso: v } })
                      .then(() => window.location.reload()).catch(() => {});
                }}
                onKeyDown={e => e.key === 'Enter' && e.target.blur()} />+ dias em aberto
            </>) : `há ${d.kpi.dias_atraso}+ dias em aberto`}
          </div>
        </div>
        <KPI t="Lojas ativas" v={d.kpi.lojas_ativas} s="cadastradas e ativas" cor="var(--verde)" />
        <KPI t="Divergências" v={d.kpi.div_pendentes} s={`pendentes · ${d.kpi.div_mes} no mês`} cor="var(--vermelho)"
          onClick={() => nav('/ordens?divergencia=1')} />
      </div>

      <div className="grid duas-colunas" style={{ gridTemplateColumns: '1.4fr 1fr' }}>
        <div className="card">
          <h3 className="card-title">OS por status</h3>
          <ResponsiveContainer width="100%" height={230}>
            <BarChart data={porStatus} margin={{ left: -20, right: 6 }}>
              <XAxis dataKey="nome" tick={{ fontSize: 10 }} interval={0} angle={-14} height={46} textAnchor="end" />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="qtd" radius={[5, 5, 0, 0]}>
                {porStatus.map((e, i) => <Cell key={i} fill={e.cor} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="card">
          <h3 className="card-title">OS por loja</h3>
          <ResponsiveContainer width="100%" height={230}>
            <PieChart>
              <Pie data={porLoja} dataKey="qtd" nameKey="nome" innerRadius={48} outerRadius={78} paddingAngle={3}>
                {porLoja.map((_, i) => <Cell key={i} fill={PIE[i % PIE.length]} />)}
              </Pie>
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="card">
        <h3 className="card-title">Últimas ordens de serviço</h3>
        <table className="tbl">
          <thead><tr><th>OS</th><th>Cliente</th><th>Loja</th><th>Lente</th><th>Status</th><th>Dias</th></tr></thead>
          <tbody>
            {d.ultimas.map(o => (
              <tr key={o.id}>
                <td><Link to={`/ordens/${o.id}`} style={{ fontWeight: 800, color: 'var(--verde)' }}>{o.numero_os}</Link></td>
                <td>{o.cliente}</td>
                <td>{o.loja_nome}</td>
                <td>{o.lente || '—'}</td>
                <td><span className="badge" style={{ background: ST_COR[o.status] + '22', color: ST_COR[o.status] }}>{ST_LABEL[o.status]}</span></td>
                <td style={{ fontWeight: 700, color: o.dias >= 5 && o.status !== 'recebido_loja' ? 'var(--vermelho)' : 'var(--cinza)' }}>{o.dias}d</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
